<div class="crop-sheet">

  <!-- Header -->
  <div class="crop-sheet__header">
    <button mat-icon-button (click)="onCancel()" class="crop-sheet__close">
      <mat-icon>close</mat-icon>
    </button>
    <h2 class="crop-sheet__title">Crop Image</h2>
    <div class="crop-sheet__spacer"></div>
  </div>

  <!-- Spinner while image loads -->
  @if (loading) {
    <div class="crop-sheet__spinner">
      <mat-spinner diameter="48"></mat-spinner>
    </div>
  }

  <!-- Cropper -->
  <div class="crop-sheet__cropper" [style.visibility]="loading ? 'hidden' : 'visible'">
    <image-cropper
      #previewImage
      [imageChangedEvent]="data.imageChangedEvent"
      [maintainAspectRatio]="false"
      [onlyScaleDown]="true"
      format="png"
      output="base64"
      [autoCrop]="true"
      [canvasRotation]="canvasRotation"
      [transform]="transform"
      (imageCropped)="onImageCropped($event)"
      (imageLoaded)="onImageLoaded()"
      (cropperReady)="onCropperReady()"
      (loadImageFailed)="onLoadImageFailed()">
    </image-cropper>
  </div>

  <!-- Actions -->
  @if (!loading) {
    <div class="crop-sheet__actions">
      <div class="crop-sheet__rotate">
        <button mat-icon-button (click)="rotateLeft()" matTooltip="Rotate left">
          <mat-icon>rotate_left</mat-icon>
        </button>
        <button mat-icon-button (click)="rotateRight()" matTooltip="Rotate right">
          <mat-icon>rotate_right</mat-icon>
        </button>
      </div>

      <div class="crop-sheet__buttons">
        <button mat-stroked-button (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="primary" (click)="onFinish()" data-testid="finishBtn">Finish</button>
      </div>
    </div>
  }

</div>
